export default "__VITE_ASSET__CNdQxEDS__"